import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, funciones } from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import BarraBotones   from '../../components/Barra_menu';
import {withStyles} from '@material-ui/core/styles';
import {Table, Grid, TableSelection, TableFixedColumns} from '@devexpress/dx-react-grid-material-ui';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import DialogContent          from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {virtual} from '../../components/VirtualListBox';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Fade from '@material-ui/core/Fade';
import Select  from '../../components/Select';
import MenuItem  from '@material-ui/core/MenuItem';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
let checkId = undefined;

var color_periodo_anterior='red';

const styles = theme => ({
 
paper: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '500px' : "98%", 
  maxWidth: !movil ? '500px' : "98%", 
},	
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
container: {
  display: 'flex',
  justifyContent: !movil ? 'center' : undefined, 
  alignItems: "center",
  flexDirection: !movil ? "row" : "column",
  paddingTop: "2px",
  paddingBottom: "5px", 
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1)
},
textField: {
 marginRight: !movil ? theme.spacing(1) : undefined,         
},
paperTitle: { 
  height: '40px', 
  textAlign: 'center',
  verticalAlign: 'middle',
  lineHeight: '40px',
  margin: "1px " + globales.tabla.marginright + "px 0px " + globales.tabla.marginleft + "px", 
},
divSecondary: {
  marginBottom: '10px'
},

select: { //CONFIGURA EL SELECT 
  margin: theme.spacing(movil?2:1, 0,0),
  padding: 0,
  //paddingRight: 5,
  width: movil?'50%':'100%',
},

});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns =  [ 
  { name: 'PERIODO', title: 'PERIODO'}, 
  { name: 'ID_SECCION_CLIENTE', title: 'ID_SECCION_CLIENTE'},
  { name: 'CODIGO_CURSO', title: 'Código'},
  { name: 'DESCRIPCION_CURSO', title: 'Descripción'},
  { name: 'CREDITOS', title: 'Uv'},
  { name: 'SECCION_DIAS', title: 'Dias'},
  { name: 'INICIO', title: 'Desde'},
  { name: 'FIN', title: 'Hasta'},
  { name: 'AULA', title: 'Aula'}, 
  { name: 'VALOR', title: 'Valor'},
  { name: 'PORCENTAJE', title: '% Retiro'},
  { name: 'DESCRIPCION_NIVEL', title: 'DESCRIPCION_NIVEL'},
  { name: 'ESTADO_SECCION', title: 'Estado'},
];
const columnExtensions = [
    { columnName: 'PERIODO', width: 0},
    { columnName: 'CODIGO_CURSO', width: widthTable * 0.07 },
    { columnName: 'DESCRIPCION_CURSO', width: !movil ? widthTable * 0.24 : 280},
    { columnName: 'CREDITOS', width: widthTable * 0.06, align: 'center'},
    { columnName: 'SECCION_DIAS', width: widthTable * 0.07, align: 'center'}, 
    { columnName: 'INICIO', width: widthTable * 0.07, align: 'center'},
    { columnName: 'FIN', width: widthTable * 0.07, align: 'center'},    
    { columnName: 'AULA', width: widthTable * 0.07, align: 'center'},  
    { columnName: 'VALOR', width: widthTable * 0.08, align: 'center'},
    { columnName: 'PORCENTAJE', width: widthTable * 0.08, align: 'center'},
    { columnName: 'ID_SECCION_CLIENTE', width: 0},
    { columnName: 'DESCRIPCION_NIVEL', width: 0},
    { columnName: 'ESTADO_SECCION', width: widthTable * 0.08, align: 'center'},
];

const grouping = [{ columnName: 'PERIODO' },{ columnName: 'DESCRIPCION_NIVEL' }];

const grouping_nivel = [{ columnName: 'DESCRIPCION_NIVEL' }];

const columnsRetiro = [
  { name: 'LABEL', title: 'Label' },
  { name: 'VALUE', title: 'Value' },
];
const columnExtensionsRetiro = [
  { columnName: 'LABEL', width: "45%", wordWrapEnabled: true }, 
  { columnName: 'VALUE', wordWrapEnabled: true },
];

const settingFilter = [

  { columnName: 'VALOR',
     predicate: (value, filter, row) => {
                value = funciones.formatCurrency(value); 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'INICIO',
     predicate: (value, filter, row) => {
                value = value !== null ? funciones.getTime(value, 1) : value;
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'FIN',
     predicate: (value, filter, row) => {
                value = value !== null ? funciones.getTime(value, 1) : value;
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'PORCENTAJE',
     predicate: (value, filter, row) => {
                value = value + "%";
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  
];

const RowId = row => row.ID_SECCION_CLIENTE;

const GroupCellContent = ({ column, row }) => {
  var color=''
  var anterior=false;

  if(row.compoundKey.search('Período Anterior')===0)
  {
    anterior=true;
    color=color_periodo_anterior;
  }
  else
    color='black';

  return(
    <span style={{color:color}}>   
      {anterior?row.value:<strong>{row.value}</strong>} 
    </span>
  );
}

const VirtualTable_cellComponent = (props) => {  
  
  if (props.column.name === 'INICIO')
  {
    return ( <Table.Cell {...props} style={{color:props.row.ES_ANTERIOR?color_periodo_anterior:'inherit'}}>
              {props.row.INICIO !== null ? funciones.getTime(props.row.INICIO, 1) : null}
             </Table.Cell>);
  }
     
  if (props.column.name === 'FIN')
  {
    return ( <Table.Cell {...props} style={{color:props.row.ES_ANTERIOR?color_periodo_anterior:'inherit'}}>
             {props.row.FIN !== null ? funciones.getTime(props.row.FIN, 1) : null}
            </Table.Cell>);
  }
  
  if (props.column.name === 'VALOR')
  {
    return (<Table.Cell {...props} style={{color:props.row.ES_ANTERIOR?color_periodo_anterior:'inherit'}}>
            {props.row.VALOR !== null ? funciones.formatCurrency(props.row.VALOR) : props.row.VALOR}        
           </ Table.Cell>
           );
  }

  if (props.column.name === 'PORCENTAJE')
  {
    return (<Table.Cell {...props} style={{color:props.row.ES_ANTERIOR?color_periodo_anterior:'inherit'}}>
            {props.row.CHECKED ? null : props.row.PORCENTAJE + "%"}        
            </ Table.Cell>
           );
  }
  
  return (<Table.Cell {...props} style={{color:props.row.ES_ANTERIOR?color_periodo_anterior:'inherit'}}/>);
       
}
const Table_cellComponentRetiro = ({style, ...props}) => {

  const styleCell = { border: "none", paddingBottom: 12 }
  
  if (props.column.name === "LABEL"){
    return (<Table.Cell style={{ ...styleCell, fontWeight: "bold"}}
            {...props}/>);
  }
      
  return (<Table.Cell style={{...styleCell, fontWeight: props.row.KEY === 4 ? "bold" : undefined }} {...props}/>);
   
}
const TableSelectionCellComponent = (estado, checkId) => ({style, ...props}) =>{
    
  if (estado && props.row.ID_SECCION_CLIENTE === checkId)
  {
   return ( <Table.Cell style={{ ...style, paddingLeft: '20px', paddingTop: "2px", paddingBottom: "0px" }} {...props}>
             <CircularProgress size={22} color="secondary"/>
           </Table.Cell> 
          );
  }  
  
  return ( <TableSelection.Cell style={style} {...props}/>);
}
const ColumnFixed_cellComponent = ({ showRightDivider, showLeftDivider, ...props}) => { 
  
  if (props.tableRow.key === "Symbol(filter)"){
    return (<TableFixedColumns.Cell {...props}>
              <div style={{ background: "white", height: "30px", width: "100%" }} />
             </TableFixedColumns.Cell>);
  }

  return (<TableFixedColumns.Cell 
            showRightDivider={false}
            showLeftDivider={false}
            style={{ backgroundColor: 'inherit' }}
            {...props} 
        />);
}
const RenderOption = (option) => (
  <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
   <ListItemAvatar style={{ minWidth: 32 }}>
    <Avatar style={{ height: 23, width: 23 }}>
     <PersonIcon size="small"/>
    </Avatar>
   </ListItemAvatar>
  <div style={{ minWidth: "55px", color: "gray" }}>{option.CUENTA_ALUMNO}</ div>
  <div>{option.NOMBRE_COMPLETO}</div>
 </ div>
);

export default withStyles(styles) ( 
class App extends React.Component {

razonRef = React.createRef();
tablaRef = React.createRef();

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       loadingMain: false,
       rows: [],
       optionAutocomplete: [],
       loadingClientes: true,
       valueAutoComplete: null,
       openAutoComplete: false,
       openModal: false,
       openModalConfirmation: false,
       expandedGroups: [],
       rowsRetiro: [],
       loadingCheck: false,
       es_anterior: false,
   };
   this.cuenta= null;
   this.botones_retiro =[
       {icono: 'Check', toolt: '', nombre: 'Retirar', onclick: this.handleRetiroOk, display:'auto'},
       {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleClose, display:'auto', color: 'red'},
    ];
}

onBlurAutoComplete = ()=>{

  if (this.state.openAutoComplete)
   this.setState({ openAutoComplete: false });    
      
} 
    
onChangeInput = (e, value)=>{ 
    
  if (e === null || e.target.value === undefined)
  {
    if (this.state.openAutoComplete) 
      this.setState({ openAutoComplete: false });
               
    return;
  }
        
  if ((e.target.value.toString().trim().length < 3 || (this.state.valueAutoComplete !== null && value === this.state.valueAutoComplete.CUENTA_ALUMNO + ' | ' + this.state.valueAutoComplete.NOMBRE_COMPLETO)) && this.state.openAutoComplete)
    this.setState({ openAutoComplete: false });
  else if (e.target.value.toString().trim().length >= 3  && !this.state.openAutoComplete)
    this.setState({ openAutoComplete: true });
         
}
    
onChangeAutocomplete = (event, value) =>{
      
 this.setState({ valueAutoComplete: value, openAutoComplete: false, rows: [] }, ()=>{
        
  if (value === null)
  {
   return;
  }
    
  this.handleChangeCuenta(null);   
        
 });
    
}
  
filtersClientes = (value)=>{ 
  
  new Request
   .get(`${globales.ip}/retiros/estudiantes/${value}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(0)
   .timeout({ response: 30000, deadline: 40000, }) 
   .end((err, res) => {
              
     if (err) { 
    
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                  
         window.location.reload();
         return;
                    
       }
        
      this.setState({ optionAutocomplete: [], openAutoComplete: false, loadingClientes: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
      });
                
      return;
     }
            
     const rows = JSON.parse(res.text);
     this.setState({ optionAutocomplete: rows, loadingClientes: false }); 
                 
       
});
    
}

onRefresh = ()=>{
  
 this.setState({ loadingClientes: true }, ()=>{ 
   this.filtersClientes('-');
 });
       
}

handleChangeCuenta = (event) => {
  
if (this.state.loadingMain)
{   
 return;
}
      
this.cuenta = (event === null && tokenInfo.plataforma === 2) ? tokenInfo.user : tokenInfo.plataforma === 1 ? this.state.valueAutoComplete.CUENTA_ALUMNO : null;
this.setState({ loadingMain: true }, ()=>{ 
            
  new Request
   .get(`${globales.ip}/retiros/oferta/${this.cuenta}/${tokenInfo.user}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(1)
   .timeout({ response: 30000, deadline: 40000, }) 
   .end((err, res) => {
              
      if (err) { 
    
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
                 
          window.location.reload();
          return;
                   
        }
      
        this.setState({ loadingMain: false}, ()=>{ 
          funciones.showToast('e', 'No hay conexión');
        });
        
        return;
      }
            
      const rows = JSON.parse(res.text); 
         
      let allGroups = [];
      let foundGroup;
      let periodo=null;
  
      rows.map((item)=>{
        foundGroup = allGroups.find(x => x === item.DESCRIPCION_NIVEL);
        if(item.PERIODO!==null)
        {
          if(item.PERIODO.search('Período Anterior')===-1)
            if (foundGroup === undefined)
            {
              allGroups.push(item.PERIODO);
              allGroups.push(item.PERIODO+'|'+item.DESCRIPCION_NIVEL);
            }
            else {
              foundGroup = undefined;
            }
        }
        else
        {
          if (foundGroup === undefined)
          {
            allGroups.push(item.DESCRIPCION_NIVEL);
          }
          else {
            foundGroup = undefined;
          }
        }
        periodo=item.PERIODO;
    
        return item;
      }); 
  
      this.setState({ rows,expandedGroups: allGroups, loadingMain: false, periodo_anterior: periodo });         
         
    });
             
});
      
}

changeExpandedGroups = expandedGroups =>
{ 
  this.setState({ expandedGroups }); 
}

changeSelection = selection => { 

  checkId = selection[0];
  const rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === selection[0]); 

  if (!rowChecked.CHECKED){

    const rowsRetiro = [{ KEY: 0, LABEL: "Curso", VALUE: rowChecked.DESCRIPCION_CURSO },
                        { KEY: 1, LABEL: "Dias transcurridos (matrícula)", VALUE: rowChecked.DIAS },
                        { KEY: 2, LABEL: "Valor porcentual a reconocer", VALUE: rowChecked.PORCENTAJE + "%" },
                        { KEY: 3, LABEL: "Valor total del curso", VALUE: funciones.formatCurrency(rowChecked.VALOR) },
                        { KEY: 4, LABEL: "Valor total a reconocer", VALUE: funciones.formatCurrency((rowChecked.VALOR * rowChecked.PORCENTAJE)/100) },];
 
    this.setState({ rowsRetiro,openModal: true,es_anterior:rowChecked.ES_ANTERIOR,periodo_anterior:rowChecked.PERIODO,selection_motivoRetiro:'',esOtro_motivoRetiro: false  });
  }
}

handleClose = ()=>{

this.setState({ openModal: false,es_anterior: false });

}

handleRetiroOk = ()=>{

let razon_final = this.razonRef.current?.value || "";

if (this.state.selection_motivoRetiro === 16 && funciones.isEmpty(razon_final)) {
  funciones.showToast("w", "Debe ingresar la razón de retiro");
  this.razonRef.current.focus();
  return;
}

if (funciones.isEmpty(this.state.selection_motivoRetiro)){
  funciones.showToast("w", "Debe ingresar el motivo de retiro");
  return;
}

this.setState({ openModal: false, loadingCheck: true }, ()=>{ 

  const rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === checkId); 

  new Request
  .post(`${globales.ip}/retiros`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .set('Content-Type', 'application/json')
  .send({ id_seccion_cliente: rowChecked.ID_SECCION_CLIENTE, 
          monto_reconocido: parseFloat(rowChecked.VALOR * rowChecked.PORCENTAJE/100), 
          porcentaje: rowChecked.PORCENTAJE,
          razon: razon_final,
          motivo_retiro:this.state.selection_motivoRetiro,
          cuenta_alumno: this.cuenta,
          ad_usuario: tokenInfo.user })
  .retry(0)
  .timeout({ response: 20000, deadline: 40000, }) 
  .end((err, res) => {
          
    if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
  
        this.setState({ loadingCheck: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión'); 
        });
        
        return;
    }
        
    const rows = JSON.parse(res.text);
  
    if (rows.length === 0 || rows[0].RESP === undefined)
    {       

      this.setState({ rows,loadingCheck: false,es_anterior: false,selection_motivoRetiro:'',esOtro_motivoRetiro:false }, ()=> {                 
         funciones.showToast("s", "Se ha retirado del curso " + rowChecked.DESCRIPCION_CURSO); 
      });     

    }
    else
    {
      this.setState({ loadingCheck: false,es_anterior: false,selection_motivoRetiro:'',esOtro_motivoRetiro:false }, ()=>{
        funciones.showToast("w", rows[0].RESP); 
      });
                    
    }
    
                
    
  });

});

}

obtenerMotivoRetiro = () => {
    new Request
      .get(`${globales.ip}/retiros/motivos/${Auth.getProfile().user}/${Auth.getProfile().user}`)
      .set({ authorization: 'Bearer ' + Auth.getToken() })
      .retry(1)
      .timeout({ response: 15000, deadline: 30000 })
      .end((err, res) => {

        if (err) {
          if (err.toString().includes('Forbidden')) {
            window.location.reload();
            return;
          }

          funciones.showToast('e', 'No hay conexión');
          this.setState({ loadingMotivoRetiro: false });
          return;
        }

        const rows = JSON.parse(res.text);
        if(rows.length>0){
          const Datos = rows.map((datos) =>
            <MenuItem dense  value={datos.ID_MOTIVO} key={datos.DESCRIPCION} >
              {datos.DESCRIPCION}
            </MenuItem>
          );
               
          this.setState({ motivoRetiro: Datos}) 
      }
   });
};

handleChangeSelect_motivoRetiro = (event) => {
  const idSeleccionado = Number(event.target.value); 
  const motivoSeleccionado = this.state.motivoRetiro.find(m => Number(m.props.value) === idSeleccionado );

  if (motivoSeleccionado) {
    const esOtro =motivoSeleccionado.props.children.trim().toUpperCase() === "OTRO";
    this.setState({selection_motivoRetiro: idSeleccionado, esOtro_motivoRetiro: esOtro });
  }
};

componentDidMount() { 

 tokenInfo = Auth.getProfile(); //Token decodificado

 this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{

  if (tokenInfo.plataforma === 1) // Usuario Admin
  {
    this.cuenta= null;
    this.filtersClientes('-');
     
  }
  else if (tokenInfo.plataforma === 2) //Usuario estudiante
  {     
    this.setState({ loadingClientes: false });
    this.handleChangeCuenta(null);   
  }
   
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }, ()=>{
    if (!movil && tokenInfo.plataforma === 1)
      document.getElementById('Est_Retiros').focus();      
  }); 

    this.obtenerMotivoRetiro()
 }); 
              
}

render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 1) //Si es Usuario Admin
            {
              
              return (
                <React.Fragment>
                 <div className={classes.container}>    
                   <Autocomplete
                     id="Est_Retiros"
                     options={this.state.optionAutocomplete}
                     getOptionLabel={(option) => option.CUENTA_ALUMNO + ' - ' + option.NOMBRE_COMPLETO}
                     style={{ width: movil ? '100%' : '430px' }}
                     renderInput={(params) => <TextField {...params} 
                                                  label="Estudiante"
                                                  variant="outlined"
                                                  onBlur={this.onBlurAutoComplete}                                                                                                                         
                                                  InputProps={{
                                                             ...params.InputProps,
                                                              endAdornment: (
                                                               <React.Fragment>
                                                                {this.state.loadingClientes ? 
                                                                <Fade in style={{
                                                                    transitionDelay: '1000ms',
                                                                  }} unmountOnExit>
                                                                  <CircularProgress size={18}/> 
                                                                </Fade>
                                                                : 
                                                                 this.state.valueAutoComplete === null ?
                                                                  <Tooltip title="Actualizar lista" placement="top">
                                                                  <IconButton style={{ width: 23, height: 23 }} onClick={this.onRefresh}>
                                                                    <RefreshIcon color="primary"/>
                                                                  </IconButton>
                                                                  </Tooltip>
                                                                 : null
                                                                }
                                                                {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                                 )
                                                            }}
                                                            fullWidth
                                                            />}
                      renderOption={RenderOption}                                 
                      onChange={this.onChangeAutocomplete}
                      open={this.state.openAutoComplete}
                      loading={this.state.loadingClientes}
                      ListboxComponent={virtual.ListboxComponent}                            
                      value={this.state.valueAutoComplete} 
                      className={classes.textField}                            
                      disableClearable={this.state.loadingMain}                            
                      onInputChange={this.onChangeInput}
                      popupIcon={null}
                      PaperComponent={(props)=>(<Paper elevation={8} {...props} />)}                                                                              
                      />                            
                   </div>
                 
                </React.Fragment>
              );

             }             
             
             if (tokenInfo.plataforma === 2){

                return(
                  <React.Fragment>
                   <Paper variant="outlined" className={classes.paperTitle}>
                    <Typography component='span' variant="h6" className="disableTouchOptions">
                      <strong>Cursos disponibles para retirar</strong>
                    </Typography>
                   </Paper>
                   <div className={classes.divSecondary}/>
                  </ React.Fragment>);
  
             } 

            })()

          }

          <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
            <CustomTable 
               Columns={columns} 
               Rows={this.state.rows}
               Grouping={this.state.periodo_anterior?grouping:grouping_nivel}                      
               TableColumnExtensions={columnExtensions} 
               columnWidths={columnExtensions} 
               DefaultHiddenColumnNames={['ID_SECCION_CLIENTE']}
               ExpandedGroups={this.state.expandedGroups}
               ChangeExpandedGroups={this.changeExpandedGroups}
               getRowId={RowId}
               VirtualTable_cellComponent={VirtualTable_cellComponent}
               height={this.state.heightTableMain} 
               loading={this.state.loadingMain}
               enabledFilterRows
               showSelectionColumn 
               groupContentComponent={GroupCellContent}
               ChangeSelection={this.changeSelection}
               tableSelectionCellComponent= {TableSelectionCellComponent(this.state.loadingCheck, checkId)}                    
               leftColumnsFixed={[TableSelection.COLUMN_TYPE]}
               columnFixedCellComponent={ColumnFixed_cellComponent}
               FilteringColumnExtensions={settingFilter}           
               />                  
              </div>
              <Dialog open= {this.state.openModal}
                      classes = {{ paper: classes.paper }}>
              <DialogTitle><Typography component='span' variant='subtitle2'>Retiro de curso</Typography>
               <IconButton className={classes.closeButton} onClick={this.handleClose} size="small">
                <CloseIcon fontSize="small" />
               </IconButton>
              </DialogTitle>
              <DialogContent style={{ paddingBottom: 20 }}>
              <Paper className="disableTouchOptions" variant="outlined" style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Grid columns={columnsRetiro}
                      rows={this.state.rowsRetiro}>
                  <Table height="auto"
                         columnExtensions={columnExtensionsRetiro}
                         cellComponent={Table_cellComponentRetiro} /> 
                </ Grid>
               </Paper>

              <Select Label="Motivo Retiro"
                Datos = {this.state.motivoRetiro}
                Selected={this.state.selection_motivoRetiro}
                onChange={this.handleChangeSelect_motivoRetiro}
                Multiple = {false}
                SelectClass={{height:movil?'auto':36}}
                Style = {classes.select}
                ShowItemNone = {true}
                LabelItemNone = ''
                ValueItemNone = ''
                AutoFocus = {false}
                Outlined = {true}
                labelWidth = {95}
                required
              />
             {this.state.esOtro_motivoRetiro===true && (
               <TextField label="Razón de retiro"
                          variant="outlined"
                          required={this.state.esOtro_motivoRetiro}
                          fullWidth
                          margin="normal"
                          inputProps={{ ref: this.razonRef, maxLength: 200 }}
               />
             )}

              {this.state.es_anterior?<Typography component='span' variant='h5' style={{color:'red',fontWeight:'bold',marginBottom:10,marginTop:5}}>Nota: El curso es del {this.state.periodo_anterior.toLowerCase()}</Typography>:null}

              </ DialogContent>
              <DialogActions>
                <BarraBotones botones={this.botones_retiro} />                  
              </DialogActions>
              </Dialog>

              <Backdrop open={this.state.loadingClientes || this.state.loadingMain || this.state.loadingCheck}
                        className={classes.backdrop} 
                        invisible 
                        transitionDuration={0}/>
          
        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)